import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-csv',
  templateUrl: './icon-csv.component.html',
  styleUrls: ['./icon-csv.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconCsvComponent {}
